<template>
  <div class="top_piece_box">
    <el-image
      src="https://oss.chinadentalshow.com/uploads/PC/top.jpg"
    ></el-image>
    <div class="container">
      <div class="box_piece">
        <div>{{ nodeArr[0].name?nodeArr[0].name :'' }}</div>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{langSet=='cn'? '首页':'Home' }}</el-breadcrumb-item>
          <el-breadcrumb-item
            v-for="(item, index) in nodeArr.slice(0, 2)"
            :key="index"
            >{{ item.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "topPiece",
  components: {},
  data() {
    return {
      langSet: 'cn',
      nodeArr: [{name:''}],
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    //25.6.16 手动追加个人资料相关菜单 dxm
    menuArr = [
      ...menuArr,
      {
        name_cn: "个人主页",
        name_en: "Homepage",
        http_url_cn: "/personal",
        children: [
          {
            name_cn: "我的收藏",
            name_en: "My Collection",
            http_url_cn: "/mycollect",
          },
          {
            name_cn: "我的商机",
            name_en: "My Business",
            http_url_cn: "/mybusiness",
          },
        ],
      },
    ];
    let path = this.$route.path;
    if (this.$route.path == "/webContent" || this.$route.path == "/webContentV") {
      path = this.$route.fullPath;
    }
    if (this.$route.path == "/companyDetail") {
      path ="/company";
    }
    if (this.$route.path == "/productDetail") {
      path ="/product";
    }  if (this.$route.path == "/liveEventsDetail") {
      path ="/liveEvents";
    }
    this.nodeArr = this.menuArrFindPath(menuArr, path);
  },
  methods: {
    menuArrFindPath(data, target) {
      const findPath = (nodes, path) => {
        for (const node of nodes) {
          let namePath={
            name:this.langSet==='cn'?node.name_cn:node.name_en,
            path:this.langSet==='cn'?node.http_url_cn:node.http_url_en
          }
         
          const currentPath = [...path,namePath];
          if (node.http_url_cn === target || node.http_url_en === target) {
            return currentPath;
          }
          if (node.children && node.children.length) {
            const result = findPath(node.children, currentPath);
            if (result) return result;
          }
        }
        return null;
      };
      return findPath(data, []);
    },
  },
};
</script>

<style scoped lang="scss">
.top_piece_box {
  position: relative;
  margin-bottom: 50px;
}

.box_piece {
  position: absolute;
  bottom: 55px;
  //left: 80px;
}

.box_piece div:nth-child(1) {
  font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
  font-weight: 700;
  font-size: 40px;
  color: #ffffff;
  line-height: 80px;
  text-align: left;
  font-style: normal;
}

/deep/ .el-breadcrumb__inner {
  color: #ffffff !important;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  text-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);
  text-align: left;
  font-style: normal;
  cursor: pointer;
}


@media only screen and (max-width: 767px) {


  .top_piece_box {
    position: relative;
    margin-bottom: 0.58rem;
    margin-top:1.15rem;


    .box_piece {
      position: absolute;
      bottom: 0.54rem;
      //left: 80px;
    }

    .box_piece div:nth-child(1) {
      font-weight: normal;
      font-size: 0.35rem;
      color: #FFFFFF;
      line-height: 0.69rem;
      text-align: left;
      font-style: normal;
    }

    /deep/ .el-breadcrumb__inner {
      font-weight: 400;
      font-size: 0.23rem;
      color: #FFFFFF  !important;
      line-height: 0.33rem;
      text-shadow: 0px 0px 0px rgba(0,0,0,0.1);
      text-align: left;
      font-style: normal;
    }


  }


}





</style>